import getPerformanceDatasetsRef from './getPerformanceDatasetsRef';

const savedProgresses = {
  getPerformanceDatasetsRef,
};

export default savedProgresses;
